import React from "react";
import { Form, Flex } from "antd";
import { Button, Icon, SearchInput } from "ui";
import { useAppStore } from "store";
import { useArticleManagementStore } from "pages/articles/store";
import { articleManagementFilter } from "pages/articles/type";

interface FormValues {
  search: string;
}
interface ArticlesActionBar {
  className?: string;
}

export const ActionBar: React.FC<ArticlesActionBar> = ({ className }) => {
  const { setModalVisibility } = useAppStore((state) => state);
  const { setFilter, setFormData } = useArticleManagementStore(
    (state) => state
  );
  const [form] = Form.useForm<FormValues>();
  const onValuesChangeHandler = (
    changedValues: FormValues,
    allValues: FormValues
  ) => {
    setFilter(
      Object.entries(changedValues)
        .filter(([_, value]) => value.length > 0)
        .map(([key, value]) => {
          return {
            propertyName: key as articleManagementFilter,
            operation: "contains",
            value: value as string,
          };
        })
    );
  };
  return (
    <Flex className={`${className} box w-100`} gap={10} justify="space-between">
      <Form
        form={form}
        className="w-100"
        onValuesChange={onValuesChangeHandler}
      >
        <Flex>
          <Form.Item name={"title"}>
            <SearchInput size="large" placeholder="جستجوی مقاله " />
          </Form.Item>
        </Flex>
      </Form>
      <Button
        type="primary"
        size="large"
        onClick={() => {
          setFormData(undefined);
          setModalVisibility("ARTICLE_MANAGEMENT_MODAL");
        }}
      >
        <Icon type="sr-plus" />
        <span>افزودن مقاله </span>
      </Button>
    </Flex>
  );
};
